import { Resultado } from './resultado.page';
import { TratamentoGatewayService } from 'projects/core/src/lib/core/TratamentoGatewayService';
import { ResponseModel } from 'projects/core/src/lib/core/model/ResponseModel';
import { FormularioTraderProvider } from 'projects/core/src/lib/core/provider/FormularioTraderProvider';
import { ThrowError } from 'projects/core/src/lib/core/ThrowError';

export class ResultadoViewModel {
    constructor() {}

    context: Resultado
    formularioTraderProvider = new FormularioTraderProvider()

    getContext(): Resultado {
        return this.context
    }

    setContext(context: Resultado) {
        this.context = context
    }

    async getResultado() {
        let retorno = await this.formularioTraderProvider.resultado()
        try {
            retorno = new TratamentoGatewayService(this.getContext()).builder(retorno)
            if (retorno.status == ResponseModel.STATUS_OK) {
                return retorno.data
            } else {
                throw new Error(ThrowError.MESSAGE_DEFAULT)
            }
        } catch (e) {}
    }

    async apiResultadoFormulairoTrader() {
        let retorno = await this.formularioTraderProvider.resultado()
        retorno = new TratamentoGatewayService(this.getContext()).builder(retorno)
        if (retorno.status == ResponseModel.STATUS_OK) {
            return retorno.data
        } else {
            throw Error()
        }
    }
}